<template>
  <div>
    <v-menu>
      <template v-slot:activator="{ on: menu }">
        <template>
          <v-btn class="color-icon button-dropdown" depressed rounded block v-on="{ ...menu }">
            <img class="typeIcon" :src="items[currentIndex].icon" />
            {{ truncatedTitle(items[currentIndex].name) }}
            <v-icon right dark>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
      </template>

      <v-list>
        <v-list-item v-for="(item, index) in items" :key="index" @click="change(index)">
          <v-list-item-title>
            <img class="typeIcon-dropdown" :src="item.icon" />
            {{ item.name }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import truncate from 'lodash/truncate';
import ViewType1 from '@/assets/viewtype-1.png';
import ViewType2 from '@/assets/viewtype-2.png';
import ViewType3 from '@/assets/viewtype-3.png';

export default {
  name: 'LessonViewChangeButton',
  props: ['selected'],
  data() {
    return {
      currentIndex: this.selected || 0,
    };
  },
  computed: {
    items() {
      return [
        {
          name: this.$t('viewWindowType1'),
          icon: ViewType1,
        },
        {
          name: this.$t('viewWindowType2'),
          icon: ViewType2,
        },
        {
          name: this.$t('viewWindowType3'),
          icon: ViewType3,
        },
      ];
    },
  },
  methods: {
    truncate,
    change(index) {
      this.$emit('select', index);
      this.currentIndex = index;
    },
    truncatedTitle(value) {
      return truncate(value, {
        length: 23,
        separator: ' ',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.button-dropdown {
  height: 45px !important;
}

@media (max-width: 1440px) {
  .button-dropdown {
    height: 43px !important;
  }
}

.typeIcon {
  max-height: 20px;
  width: auto;
  padding-right: 10px;
}

.typeIcon-dropdown {
  padding-top: 5px;
  width: auto;
  max-height: 18px;
  padding-right: 10px;
}
</style>
